import { render, staticRenderFns } from "./UnmatchedDeckEditor.vue?vue&type=template&id=d20ba91c&"
import script from "./UnmatchedDeckEditor.vue?vue&type=script&lang=js&"
export * from "./UnmatchedDeckEditor.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedDeckEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports